export default "__VITE_ASSET__k5WYxLSo__"